import { render, staticRenderFns } from "./ItemsOnly.vue?vue&type=template&id=c661054c&"
import script from "./ItemsOnly.vue?vue&type=script&lang=js&"
export * from "./ItemsOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ItemsOnly.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c661054c')) {
      api.createRecord('c661054c', component.options)
    } else {
      api.reload('c661054c', component.options)
    }
    module.hot.accept("./ItemsOnly.vue?vue&type=template&id=c661054c&", function () {
      api.rerender('c661054c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/ItemsOnly.vue"
export default component.exports